const miscRegex = /<u>(.*?)<\/u>/g

const extractMiscText = text =>
  (text || '').replace('/\n/g', ' ').match(miscRegex)

export default extractMiscText
